import { useNormalizedPixels } from '../../../../hooks/useResize';
import { getScaleSize } from '../../../../utils/utils';

interface Template3LogoProps {
  scale: number;
  url: string;
}

const Template3Logo = ({ scale, url }: Template3LogoProps) => {
  const { normalizePixels } = useNormalizedPixels();

  return (
    <div
      id="logo-container"
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        marginBottom: getScaleSize(normalizePixels(21, 'height'), scale),
        height: getScaleSize(normalizePixels(50, 'height'), scale),
      }}
    >
      <img src={url} alt="Brand logo" height={'100%'} style={{ objectFit: 'contain' }} />
    </div>
  );
};

export default Template3Logo;
